import { Button, EButtonColor } from '@web_opxp/components';
import { FirebaseSelectors, RemoteConfigService, StatsSelectors, useTranslation } from '@web_opxp/features';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, Action } from 'redux';
import { AssetsBaseUrl } from '../../assets';
import { DEFAULT_EXTRA_MODES, GAMEPLAY_FULLSCREEN, SKELETON_CLASSNAME } from '../../base/constants';
import ENV from '../../base/env';
import { FULLSCREEN_CLASS } from '../../base/fullscreenHelper';
import { IState } from '../../store/state';
import { gameModeChangedEvent } from '../firebaseActions';
import { ExerciseActions } from '../slice';

interface ISecondIntroViewButtonProps {
  difficulty: number;
  loading: boolean;
}

export default function SecondIntroViewButton({ difficulty, loading }: Readonly<ISecondIntroViewButtonProps>) {
  const { t } = useTranslation();
  const dispatch = useDispatch<Dispatch<Action<string>>>();
  const firebaseReady = useSelector(FirebaseSelectors.isReady);
  const extraModesEnabled = firebaseReady
    ? RemoteConfigService.getBooleanConfigValue(ENV.RemoteConfigExtraModes, DEFAULT_EXTRA_MODES)
    : false;
  const fullscreen = useSelector((state: IState) => StatsSelectors.getStatBooleanValueById(state, GAMEPLAY_FULLSCREEN));
  const skeletonClass = loading ? SKELETON_CLASSNAME : '';
  if (!extraModesEnabled) {
    // return default learning mode button
    const fullscreenClass = fullscreen ? FULLSCREEN_CLASS : '';
    const buttonLabel = t('Exercise.PreWorkout.Learning');
    const learningModeButtonClass = `${skeletonClass} ${fullscreenClass}`;
    const buttonClickHandler = () => dispatch(ExerciseActions.startExerciseLearning(difficulty));
    return (
      <Button
        disabled={loading}
        className={learningModeButtonClass}
        label={buttonLabel}
        color={EButtonColor.white}
        onClick={buttonClickHandler}
      />
    );
  }
  // if extra modes enabled render button for opening modes selection screen
  const buttonLabelTxt = t('Exercise.PreWorkout.ExtraModes');
  const modesIcon = (
    <img data-testid="extra-modes-icon" src={`${AssetsBaseUrl}/feature/icons/ExtraModes.svg`} alt={buttonLabelTxt} />
  );
  const buttonLabel = (
    <>
      {modesIcon}
      {buttonLabelTxt}
    </>
  );
  const extraModesButtonClass = `extra-modes-button ${skeletonClass}`;
  const extraModesClickHandler = () => {
    // track event on firebase
    dispatch(gameModeChangedEvent());
    // open modes selection screen
    dispatch(ExerciseActions.openExtraModes(difficulty));
  };
  return (
    <Button
      disabled={loading}
      className={extraModesButtonClass}
      label={buttonLabel}
      color={EButtonColor.white}
      onClick={extraModesClickHandler}
    />
  );
}
